module.exports = __webpack_public_path__ + "static/media/w4.912fd2df.svg";